import { gql } from '@apollo/client';
export const CREATE_ENROLLMENT_FIELDS = gql`
  fragment CreateEnrollmentFields on EnrollmentDto {
    id
    courseId
  }
`;